module.exports = __webpack_public_path__ + "static/img/img-classification.58de2f38.png";